import React, { useState } from "react";
import "./css/dpi-admin.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import API_BASE_URL from "./config";
//import login from "./img/login.jpg";
import img_login_1 from "./img/login_1.jpg";
/*import login_2 from "./img/login_2.jpg";
import login_3 from "./img/login_3.jpg";*/

/*async function validate(userinput) {
  return fetch("http://localhost/dpiwebapi/api/ValidateUser.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ "userinput": userinput }),
  }).then((data) => data.json());
}*/

function Login({ setUser }) {
  const [userinput, setUserInput] = useState([]);

  let navUser = useNavigate();
  const [errors, setErrors] = useState();

  const handleSubmit = async (event) => {
    //sessionStorage.setItem("user_name", username);
    if (validateUserFields()) {
      event.preventDefault();
      const usercredential = await authenticateUser(userinput);
      if (usercredential.message) {
        setErrors(usercredential.message);
      } else {
        setUser(usercredential);
        navUser("/");
      }
    }
  };

  const validateUserFields = () => {
    let formErrors = "";
    //console.log(userinput.user_name === undefined);
    if (
      userinput.user_name === undefined ||
      userinput.user_name === null ||
      userinput.user_name === ""
    ) {
      formErrors = "User name or password cann't be empty";
    }
    if (
      userinput.pwd === undefined ||
      userinput.pwd === null ||
      userinput.pwd === ""
    ) {
      formErrors = "User name or password cann't be empty";
    }

    if (formErrors !== "") {
      setErrors(formErrors);
    }

    return formErrors === "";
  };

  async function authenticateUser(userinput) {
    const userFormData = new FormData();
    userFormData.append("userinput", JSON.stringify(userinput));

    const usersaver = await axios.post(
      `${API_BASE_URL}ValidateUser.php`,
      userFormData,
      {
        hearders: { "Content-Type": "multipart/form-data" },
      }
    );
    return usersaver.data;
  }
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-6 d-none d-lg-block b bg-login-image"></div>
                  <div className="col-lg-6">
                    <div className="p-5">
                      <div className="text-center">
                        <label className="small text-danger">
                          {errors}&nbsp;
                        </label>
                      </div>
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>
                      </div>
                      <form className="user">
                        <div className="form-group">
                          <input
                            className="form-control form-control-user"
                            id="user_name"
                            placeholder="User Name"
                            onChange={(e) =>
                              setUserInput({
                                ...userinput,
                                user_name: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control form-control-user"
                            id="pwd"
                            placeholder="Password"
                            onChange={(e) =>
                              setUserInput({
                                ...userinput,
                                pwd: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <div className="custom-control custom-checkbox small">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customCheck"
                            />
                            <label
                              className="custom-control-label"
                              for="customCheck"
                            >
                              Remember Me
                            </label>
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary btn-user btn-block"
                          onClick={(e) => handleSubmit(e)}
                        >
                          Login
                        </button>
                        <hr />
                      </form>
                      <hr />
                      <div className="text-center">
                        <a className="small" href="forgot-password.html">
                          Forgot Password?
                        </a>
                      </div>
                      <div className="text-center">
                        <a className="small" href="register.html">
                          Request a New Account!
                        </a>
                      </div>
                      <div>&nbsp;</div>
                      <div>&nbsp;</div>
                      <div>&nbsp;</div>
                      <div>&nbsp;</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Login;

Login.propTypes = {
  setUser: PropTypes.func.isRequired,
};
